import PosVendaAtividadeService from "@/services/PosVendaAtividadeService";
import store from "@/store"
import moment from "moment"
export const actions = {
  cadastrarAtividadePosVenda: ({ commit, dispatch }) => {
    commit("setAtividadePosVenda", {
      id: "",
      descricao: "",
      data_atividade: moment().format("YYYY-MM-DD"),
      hora_atividade: moment().format("HH:ss"),
      pos_venda_id: "",
    }),
      dispatch("setModalCadastroAtividadePosVenda", true);
  },
  listarAtividadesPosVenda: ({ commit }, data) => {
    commit("setOverlay", true);
    PosVendaAtividadeService.listar(data)
      .then((res) => {
        commit("setOverlay", false);
        commit("setAtividadesPosVenda", res.data);
      })
      .catch((e) => {
        commit("setOverlay", false);
        console.log(e);
      });
  },
  visualizarAtividadePosVenda: ({ commit, dispatch }, data) => {
    commit("setAtividadePosVenda", { ...data });
    dispatch("setModalCadastroAtividadePosVenda", true);
  },
  salvarAtividadePosVenda: ({ commit, dispatch }, data) => {
    commit("setOverlay", true);
    PosVendaAtividadeService.salvar(data)
      .then((res) => {
        // commit('addPosVenda', res.data)
        commit("setAtividadePosVenda", res.data);
        commit("setOverlay", false);
        commit("snackbarSuccess", "Registro salvo.");
        dispatch("listarAtividadesPosVenda", store.getters.getPosVenda);
        dispatch("setModalCadastroAtividadePosVenda", false);
      })
      .catch((e) => {
        if (e.response.status == 422) {
          commit("alertError", e.response.data.errors);
        }
        console.log(e);
        commit("setOverlay", false);
        commit("snackbarError", "Erro ao cadastrar.");
      });
  },
  atualizarAtividadePosVenda: ({ commit, dispatch }, data) => {
    commit("setOverlay", true);
    PosVendaAtividadeService.atualizar(data)
      .then((res) => {
        commit("setOverlay", false);
        commit("snackbarInfo", "Registro atualizado.");
        dispatch("listarPosVendas", {});
      })
      .catch((e) => {
        // if(e.response.status == 422){
        //     commit('alertError', e.response.data.errors)
        // }
        console.log(e);
        commit("setOverlay", false);
        commit("snackbarError", "Erro ao atualizar.");
      });
  },
  excluirAtividadePosVenda: ({ commit, dispatch }, id) => {
    commit("setOverlay", true);
    dispatch("setModalExcluirAtividadePosVenda", false);
    dispatch("setModalCadastroAtividadePosVenda", false);
    PosVendaAtividadeService.excluir(id)
      .then((res) => {
        dispatch("listarAtividadesPosVenda", store.getters.getPosVenda);
        commit("setOverlay", false);
        commit("snackbarError", "Registro excluído.");
      })
      .catch((e) => {
        console.log(e);
        commit("setOverlay", false);
        commit("snackbarError", "Erro ao excluir.");
      });
  },
  setModalCadastroAtividadePosVenda: ({ commit }, status) => {
    commit("setModalCadastroAtividadePosVenda", false);
    setTimeout(() => {
      commit("setModalCadastroAtividadePosVenda", status);
    }, 100);
  },
  setModalExcluirAtividadePosVenda: ({ commit }, status) => {
    commit("setModalExcluirAtividadePosVenda", false);
    setTimeout(() => {
      commit("setModalExcluirAtividadePosVenda", status);
    }, 100);
  },
};

export default {};
